export default __webpack_public_path__ + "static/media/filter_icon_elevator.f816bb01.svg";